import { FaShieldAlt, FaLock } from "react-icons/fa";

export default function PermissionLoading() {
  return (
    <div className="min-h-[80vh] w-full flex items-center justify-center p-6">
      <div className="relative w-full max-w-md rounded-3xl p-8 shadow-2xl flex flex-col items-center text-center overflow-hidden animate-in fade-in zoom-in duration-300">
        {/* Ambient Glow Background Effect */}
        <div className="absolute -top-20 -left-20 w-40 h-40 bg-sky-500/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-indigo-500/20 rounded-full blur-3xl pointer-events-none" />

        {/* Animated Security Icon Container */}
        <div className="relative mb-16 mt-8">
          {/* Pulsing Outer Rings */}
          <div className="absolute -inset-4 rounded-full bg-gradient-to-r from-sky-500 to-indigo-600 opacity-25 animate-ping" />
          <div className="absolute -inset-2 rounded-full bg-gradient-to-r from-sky-400 to-blue-600 opacity-40 animate-pulse blur-xs" />

          <div className="relative w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-tr from-sky-500 via-indigo-600 to-blue-700 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-indigo-500/30">
            <FaShieldAlt className="text-2xl sm:text-3xl animate-bounce" />
            <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-white dark:bg-slate-800 rounded-full flex items-center justify-center text-sky-600 dark:text-sky-400 shadow-md">
              <FaLock size={10} />
            </div>
          </div>
        </div>

        {/* Title & Description */}
        <h3 className="text-lg sm:text-xl font-black bg-gradient-to-r from-gray-900 via-indigo-950 to-sky-900 dark:from-white dark:via-sky-200 dark:to-indigo-200 bg-clip-text text-transparent mb-2">
          Securing Workspace Access...
        </h3>

        <p className="text-xs text-gray-500 dark:text-slate-400 font-semibold max-w-xs mb-6 leading-relaxed">
          Validating account permissions and loading authorized page resources.
        </p>

        {/* Progress Bar & Pulse Dots */}
        <div className="w-full space-y-3">
          <div className="w-full bg-gray-100 dark:bg-slate-800 rounded-full h-2 overflow-hidden p-0.5">
            <div
              className="bg-gradient-to-r from-sky-500 via-indigo-500 to-blue-600 h-full rounded-full animate-[shimmer_1.5s_infinite] bg-[length:200%_100%]"
              style={{ width: "100%" }}
            />
          </div>

          <div className="flex items-center justify-center gap-2">
            <span className="text-[10px] font-extrabold uppercase tracking-widest text-sky-600 dark:text-sky-400">
              Authorization Check Active
            </span>
            <div className="flex gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-sky-500 animate-ping" />
              <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-ping delay-150" />
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-ping delay-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
